const infractionSituationTypeInfractionAPI = require('../infraction/infractionSituationType');

const infractionSituationType = {
  scam: 0,
  accountTakeover: 1,
  corecion: 2,
  fraudulentAccess: 3,
  other: 4,
  unkown: 5,
  convertToJDPI(type) {
    switch (type) {
      case infractionSituationTypeInfractionAPI.SCAM:
        return this.scam;
      case infractionSituationTypeInfractionAPI.ACCOUNT_TAKEOVER:
        return this.accountTakeover;
      case infractionSituationTypeInfractionAPI.COERCION:
        return this.corecion;
      case infractionSituationTypeInfractionAPI.FRAUDULENT_ACCESS:
        return this.fraudulentAccess;
      case infractionSituationTypeInfractionAPI.OTHER:
        return this.other;
      case infractionSituationTypeInfractionAPI.UNKNOWN:
        return this.unkown;
      default:
        throw new Error('Invalid infraction situation type to convert to JDPI');
    }
  },
  convertFromJDPI(type) {
    switch (type) {
      case this.scam:
        return infractionSituationTypeInfractionAPI.SCAM;
      case this.accountTakeover:
        return infractionSituationTypeInfractionAPI.ACCOUNT_TAKEOVER;
      case this.corecion:
        return infractionSituationTypeInfractionAPI.COERCION;
      case this.fraudulentAccess:
        return infractionSituationTypeInfractionAPI.FRAUDULENT_ACCESS;
      case this.other:
        return infractionSituationTypeInfractionAPI.OTHER;
      case this.unkown:
        return infractionSituationTypeInfractionAPI.UNKNOWN;
      default:
        throw new Error('Invalid infraction situation type to convert from JDPI');
    }
  }
};

module.exports = infractionSituationType;
